type IgnoreRule = string | RegExp;

/**
 * 上报忽略规则
 *·
 * 你可以通过string或者正则来匹配要过滤上报的信息，可以匹配errorClass、errorMessage以及userAgent
 *
 * 例如：[/micromessenger/i, 'UnhandledRejection', /^Failed to execute 'insertBefore' on 'Node'/]
 */
export default [
    'OFF_LINE', // 离线
    'CANCEL',
    /UnhandledRejection/i,
    /^Loading CSS chunk/,
    'ChunkLoadError',
    /vivoNewsDetailPage.getNewsReadStatus4Vivo/,
    /\.NET CLR/, // 特殊爬虫环境
    // https://app.bugsnag.com/tigerbrokers/fed-tiger-open-account/errors/5c55f2593ff44c0019ed5ffb
    /^Blocked a frame with origin/,
    13035, // /fund/balance 接口 access denied
    13036, // plaid失败
    11082, // wrong verification
    13037, // 持卡人不匹配
    9999, // 记录无法撤回
    11012, // 图形验证码风险过高
    11002, // To secure your account, please verify your email address.
    11001, // 为了账号安全，请您验证手机号。
    11054, // 用户名或密码错误累计已 5 次，当前账户已被锁定（3 小时），忘记密码请尝试找回，如有疑问请联系客服。
    13111, // Please do not submit duplicate application requests.
    /Illegal invocation/,
    /Validation of trade password is required/,
    /Failed to query bank balance/,
    /Account is not open/,
    /This bank account has already been linked, please try another one/,
    403052 // plaid没有匹配到当前银行卡
] as IgnoreRule[];
